/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */

import { Result } from '../../utility/result.js';
import { TypeBrand } from './type-brand.js';

function GenericAsciiString(maxLength: number) {
  function validate(value: string): string | null {
    if(value.length > maxLength) {
      return `string {${value}}, is longer than the max allowed length of {${maxLength}} characters`;
    }

    for(let i = 0; i < value.length; i++) {
      const charCode = value.charCodeAt(i);
      if(charCode < 32 || charCode > 127) {
        return `string {${value}}, is not a valid ASCII string, because at position {${i}}, character {${value.charAt(i)}} is not a printable ASCII character`;
      }
    }

    return null;
  }

  class BoundedAsciiString {
    constructor(
        public readonly __value: string,
    ) {}

    static make(value: string): BoundedAsciiString {
      const error = validate(value);
      if(error !== null) {
        throw new Error(error);
      }

      return new BoundedAsciiString(value);
    }

    static makeOrNull(value: string): BoundedAsciiString | null {
      const error = validate(value);
      if(error !== null) {
        return null;
      }

      return new BoundedAsciiString(value);
    }

    static makeSafe(value: string): Result<BoundedAsciiString, string> {
      const error = validate(value);
      if(error !== null) {
        return Result.error(error);
      }

      return Result.ok(new BoundedAsciiString(value));
    }

    asString(): string {
      return this.__value;
    }
  }

  return BoundedAsciiString;
}

export interface AsciiString20 {
  __AsciiString20Brand: TypeBrand;
}

export class AsciiString20 extends GenericAsciiString(20) {
  static make(value: string): AsciiString20 {
    return super.make(value) as AsciiString20;
  }

  static makeOrNull(value: string): AsciiString20 | null {
    return super.makeOrNull(value) as AsciiString20 | null;
  }

  static makeSafe(value: string): Result<AsciiString20, string> {
    return super.makeSafe(value) as Result<AsciiString20, string>;
  }
}

export interface AsciiString80 {
  __AsciiString80Brand: TypeBrand;
}

export class AsciiString80 extends GenericAsciiString(80) {
  static make(value: string): AsciiString80 {
    return super.make(value) as AsciiString80;
  }

  static makeOrNull(value: string): AsciiString80 | null {
    return super.makeOrNull(value) as AsciiString80 | null;
  }

  static makeSafe(value: string): Result<AsciiString80, string> {
    return super.makeSafe(value) as Result<AsciiString80, string>;
  }
}

export interface AsciiString120 {
  __AsciiString120Brand: TypeBrand;
}

export class AsciiString120 extends GenericAsciiString(120) {
  static make(value: string): AsciiString120 {
    return super.make(value) as AsciiString120;
  }

  static makeOrNull(value: string): AsciiString120 | null {
    return super.makeOrNull(value) as AsciiString120 | null;
  }

  static makeSafe(value: string): Result<AsciiString120, string> {
    return super.makeSafe(value) as Result<AsciiString120, string>;
  }
}

